'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('sub-list', {
      url: '/sub/list',
      template: '<sub-list></sub-list>'
    });
}



// WEBPACK FOOTER //
// ./client/app/directories/sub/sub-list.routes.js